import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { DialogService } from "src/app/providers/dialog.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { EditAccessComponent } from "src/app/shared/components/edit-access/edit-access.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-access-control",
  templateUrl: "./access-control.component.html",
  styleUrls: ["./access-control.component.scss"],
})
export class AccessControlComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  functionalityList: any = [];
  constructor(
    private navservice: NavigationService,
    private dialog: MatDialog,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private route: ActivatedRoute,
    private ds: DialogService
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID
      ) {
        this.functionalityList = [];
        if (resdata.result) {
          this.functionalityList = resdata.result;
        }
      }
      this.loader = false;
      this.ls.showLoader = false;
    });
  }
  openeditaccess() {
    let data = {
        data: this.functionalityList,
        employeeHash: this.employeeHash,
      }
    let dref = this.ds.openFullScreenDialog(EditAccessComponent, data);

    dref.afterClosed().subscribe((data) => {
      if (data) {
        this.apiservice.getFunctionalityByEmployeeId(this.employeeHash);
      }
    });
  }

  employeeHash: any;
  loader: boolean = false;
  ngOnInit(): void {
    this.loader = true;
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.employeeHash = data.employeeHash;
      }
    });
    this.ls.showLoader = true;
    this.apiservice.getFunctionalityByEmployeeId(this.employeeHash);
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
